import store from '@Redux/store';

export const getCheckoutDetail = (detailName: 'billingAddress' | 'shipmentAddress'): any => {
	return store.getState().checkout[detailName] ?? {};
};
